export default "__VITE_ASSET__14c60702__"